import { useEffect, useState } from "react";
import api from "../lib/api";
import * as Icons from "lucide-react";

export const LostReasonModal = ({ lead, onClose, onConfirm }) => {
  const [reasons, setReasons] = useState([]);
  const [reason, setReason] = useState("");
  const [notes, setNotes] = useState("");
  useEffect(() => { api.get("/settings").then((r) => setReasons(r.data.lost_reasons || [])).catch(() => {}); }, []);
  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" data-testid="lost-reason-modal">
      <div className="bg-card border border-border rounded-lg shadow-xl w-full max-w-md p-5 space-y-4">
        <div className="flex items-start justify-between">
          <div>
            <h3 className="font-head font-bold text-lg flex items-center gap-2"><Icons.XCircle size={18} className="text-red-500" /> Mark as Lost</h3>
            <p className="text-sm text-muted-foreground">{lead.first_name} {lead.last_name} · {lead.uid}</p>
          </div>
          <button onClick={onClose} className="text-muted-foreground hover:text-foreground"><Icons.X size={18} /></button>
        </div>
        <div>
          <label className="label-caps">Reason category</label>
          <select value={reason} onChange={(e) => setReason(e.target.value)} data-testid="lost-reason-select"
            className="w-full mt-1 px-3 py-2 rounded-md border border-input bg-background">
            <option value="">— Select a reason —</option>
            {reasons.map((r) => <option key={r} value={r}>{r}</option>)}
          </select>
        </div>
        <div>
          <label className="label-caps">Notes</label>
          <textarea value={notes} onChange={(e) => setNotes(e.target.value)} rows={3} data-testid="lost-notes-input"
            placeholder="What happened? e.g. competitor quoted $1,200 less for a similar system" className="w-full mt-1 px-3 py-2 rounded-md border border-input bg-background resize-y" />
        </div>
        <div className="flex justify-end gap-2">
          <button onClick={onClose} className="px-4 py-2 rounded-md border border-border text-sm font-medium" data-testid="lost-cancel">Cancel</button>
          <button onClick={() => reason && onConfirm(reason, notes)} disabled={!reason} data-testid="lost-confirm"
            className="px-4 py-2 rounded-md bg-red-600 text-white text-sm font-semibold disabled:opacity-50">Mark Lost</button>
        </div>
      </div>
    </div>
  );
};
